import React, { useCallback, useMemo } from 'react';

import { Authorise } from '/imports/ui/components/Authorise';
import type { MessagesNav } from '/imports/ui/pages/user/messages/Messages';
import type { IdeRouteParams, PartialIdeNavigation } from './routes';
import { ideLink, ideRoute } from './routes';

const Ide = React.lazy(() => import('./IdeLoader'));

const IdeRoute = ({ projectId, fileKey, snapshotId, showSolution, section }: IdeRouteParams) => {
  const navigate = useCallback<PartialIdeNavigation>(
    (params) => ideLink({ projectId, fileKey, snapshotId, showSolution, ...params }),
    [projectId, fileKey, snapshotId, showSolution],
  );

  const messagesNav: MessagesNav = useMemo(
    () => ({ section, sectionLink: (section) => navigate({ section }) }),
    [section, navigate],
  );

  return (
    <Authorise>
      <Ide
        projectId={projectId}
        fileKey={fileKey}
        snapshotId={snapshotId}
        showSolution={showSolution}
        navigate={navigate}
        messagesNav={messagesNav}
      />
    </Authorise>
  );
};

export const ideRouter = ideRoute.parser.map((props) => <IdeRoute {...props} />);
